/* This file is autogenerated, see readme.md for instructions */
import ChevronRightFillSvgIcon from '@bloomreach/banana-theme/icons/chevron-right-fill.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ChevronRightFillIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ChevronRightFillSvgIcon />
    </Icon>
  );
});

ChevronRightFillIcon.displayName = 'ChevronRightFillIcon';

export default ChevronRightFillIcon;
